export default {
    label_task:{
        en:"Dealers Target",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Dealer Target",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Dealer Target",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Dealer Target",
        bn:'ব্যবহারকারীর বিবরণ'
    },

}